module.exports = __webpack_public_path__ + "assets/img/Edito_Mouhammed-Choukeir_cover.d2323c9f-ps.jpg";